module.exports = __webpack_public_path__ + "0e45925ddc996133d927262bfcd02d6f.fbx";